import React,{useEffect} from 'react'
import { checkUserApi } from '../http/api';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Auth = ({children}) => {

    const alias = localStorage.getItem('alias');

    const navigate = useNavigate();


    const checkUser = async () => {
        try {
           const response = await axios.post(checkUserApi, { alias:alias });
           if(response?.data?.status == '2'){
            //user not found 
        
            navigate('/subscribe')
           }
           else if(response?.data?.status == '1'){
            navigate('/subscribe')
           }
           else {
            // navigate('/')
           }
        }
        catch (error) {
            console.error('Error checking user:', error);   
        }
    } 
    
    
    useEffect(() => {
        if(!alias){
            navigate('/subscribe')
        }
        checkUser();
    }, []);

  return (
    <>
      {children}
    </>
  )
}

export default Auth
